export default "__VITE_ASSET__CWyZ2YSF__"